import {useState, useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import api from 'api/Api';
import logo from 'logo.svg';
import BlockIcon from '@material-ui/icons/Block';
import {useLocation} from 'react-router-dom';
const useStyles = makeStyles (theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
const closeWindow = () => {
  window.opener = null;
  window.open ('', '_self');
  window.close ();
};
const BlockView = () => {
  const classes = useStyles ();
  const location = useLocation ();
  var data = 'N/A';
  var link = '{please fill in the link}'
  console.log(location.state)
  if (location.state) {
    var {data, link} = location.state;
  }

  console.log (data);
  console.log (link);
  const sendEmail = () => {
    const urlLink = link || '{please fill in the link}';
    const mail_id = data?.mail_id || '{please fill in the mail id}';
    window.location.href = `mailto:response@greenradar.com?subject=[${mail_id}] Website Block Investigation Request &body=Dear Support Team,%0D%0A 
    %0D%0A
    Please look into possible incorrect blocking of website reported with the following info:%0D%0A
    %0D%0A
    url: ${urlLink}%0D%0A%0D%0A
    mail Id: ${mail_id}%0D%0A%0D%0A
    `;
  };
  return (
    <Grid container spacing={1} style={{overflow: 'scroll'}}>
      <Grid item xs={12} className={classes.modal}>

        <img style={{maxWidth: '20vh'}} src={logo} alt="logo" />

      </Grid>
      <Grid item xs={12} className={classes.modal}>
        <BlockIcon style={{fontSize: '10rem'}} color="error" />
      </Grid>

      {/* <Grid item xs={12}>
     

        <Typography
          // className={classes.description}
          align="center"
          color="textPrimary"
          variant="h3"
        >
          This website is blocked as it contains potentially harmful contents
        </Typography>
      </Grid> */}
      <Grid item xs={12}>
        <Typography align="center" color="textPrimary" variant="h6">
        This website is blocked as it contains potentially harmful contents
        </Typography>

      </Grid>
      <Grid
        item
        xs={12}
        style={{textAlign: 'center', justifyContent: 'center'}}
      >
        <Button variant="outlined" onClick={sendEmail}>
          Contact Green Radar
        </Button>
        {/* <a href="https://www.greenradar.com/contact-us/"> */}
        {/* Contact Green Radar */}
        {/* </a> */}
      </Grid>
    </Grid>
  );
};

// let expires = new Date()
//     expires.setTime(expires.getTime() + (response.data.expires_in * 1000))
//     setCookie('access_token', response.data.access_token, {path: '/',  expires})
export default BlockView;
